import type { ReactNode } from 'react'
import { CheckCircle2, SquareArrowOutUpRight } from 'lucide-react'

/**
 * How every flow ends (Nov 4 2026, the Coinbase pattern): one check in a soft green disc, one headline ("Swap complete"),
 * the amount under it, a link to the transaction, then whatever the flow has to show (the summary list, the route, the
 * fee receipt). The dialog footer keeps the one Done button. Swap, the exchange convert and withdraw ended three
 * different ways before; the progress card (flow-progress.tsx) ends its flows with the same disc.
 */
export function FlowDone({ title, amount, note, link, children }: { title: string; amount?: ReactNode; note?: ReactNode; link?: { label?: string; href: string } | null; children?: ReactNode }) {
  return (
    <div className="grid gap-4">
      <div className="flex flex-col items-center gap-1.5 py-2 text-center">
        <span className="mb-1 flex size-12 items-center justify-center rounded-full bg-accent-soft" aria-hidden="true">
          <CheckCircle2 className="size-6 text-accent" />
        </span>
        <div className="text-lg font-semibold">{title}</div>
        {amount ? <div className="text-sm tabular-nums">{amount}</div> : null}
        {note ? <div className="text-xs text-muted">{note}</div> : null}
        {link ? (
          <a className="mt-1 inline-flex items-center gap-1 text-sm font-medium text-accent hover:underline" href={link.href} target="_blank" rel="noreferrer">
            {link.label ?? 'View transaction'} <SquareArrowOutUpRight className="size-3.5" aria-hidden="true" />
          </a>
        ) : null}
      </div>
      {children}
    </div>
  )
}
